import { formatCurrency } from 'util/currency';

type DefaultValueFormatterOptions = {
  valueFormatter?: (value: string | number) => string;
  numberFormatOptions?: Intl.NumberFormatOptions;
};

export const defaultValueFormatter = (
  value: string | number,
  valueType: 'number' | 'currency' | 'percent' | 'string',
  { valueFormatter, numberFormatOptions }: DefaultValueFormatterOptions = {},
): string | undefined => {
  if (value == null) return undefined;

  if (valueFormatter) return valueFormatter(value);

  if (valueType === 'currency') {
    return formatCurrency(value.toString());
  } else if (valueType === 'percent') {
    return value.toLocaleString(undefined, {
      style: 'percent',
      minimumFractionDigits: 1,
      ...numberFormatOptions,
    });
  } else if (valueType === 'number') {
    return value.toLocaleString(undefined, numberFormatOptions);
  }

  return value.toString();
};
